import { __assign } from "tslib";
import { createAction } from 'redux-actions';
import { actionKey } from './constants';
var fileUploadIndex = 0;
export var uploadFile = createAction(actionKey + "/UPLOAD", function (payload) { return (__assign(__assign({}, payload), { fileId: ++fileUploadIndex })); });
export var uploadSuccess = createAction(actionKey + "/UPLOAD/SUCCESS", function (fileId) { return ({ fileId: fileId }); });
export var uploadFailure = createAction(actionKey + "/UPLOAD/FAILURE", function (fileId, error) { return ({ fileId: fileId, error: error }); });
export var uploadProgress = createAction(actionKey + "/UPLOAD/PROGRESS", function (fileId, progress) { return ({ fileId: fileId, progress: progress }); });
//# sourceMappingURL=actions.js.map